<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      size="xl"
      hide-footer
      footer-class="pt-0 border-0"
    >
      <template #modal-header="{ close }">
        <div class="modal-title">สินค้า</div>
        <button type="button" aria-label="Close" class="close" @click="close">
          ×
        </button>
      </template>
      <div class="bg-white border-red">
        <div class="d-block">
          <b-tabs v-model="tabIndex">
            <b-tab :title="`ทั้งหมด (${all.rows})`">
              <div class="d-flex justify-content-start align-items-end">
                <InputText
                  placeholder="ค้นหาสินค้า"
                  v-model="all.filter.search"
                  textFloat="ค้นหา"
                  type="text"
                  name="search_product"
                  faIcon="search"
                  className="my-2 w-50"
                  @onEnter="(val) => handleSearch(val, 'all')"
                  @onClickIcon="(val) => handleSearch(val, 'all')"
                />
                <div>
                  <img
                    src="@/assets/images/icons/bin.png"
                    alt="delete"
                    class="pointer mb-2 ml-2"
                    center
                    width="32"
                    @click="handleSearch('', 'all')"
                  />
                </div>
              </div>
              <b-row>
                <b-col>
                  <b-table
                    responsive
                    striped
                    hover
                    :fields="fields"
                    :items="all.items"
                    :busy="all.isBusy"
                    show-empty
                    empty-text="No matching records found"
                    class="table-main"
                    :no-border-collapse="false"
                  >
                    <template v-slot:cell(select)="data">
                      <b-button
                        variant="primary-color"
                        class="btn-modal btn-hover"
                        @click="selectRow(data.item, 'all')"
                        :disabled="all.isBusy"
                      >
                        เลือก
                      </b-button>
                    </template>
                    <template v-slot:cell(name)="data">
                      <b>{{ data.item.name || "-" }}</b>
                      <p>{{ data.item.category_name || "-" }}</p>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div>
                        {{ data.item.price | numeral("0,0.00") }}
                      </div>
                    </template>
                    <template v-slot:table-busy>
                      <div class="text-center text-black my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-2">Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <Pagination
                @handleChangeTake="(val) => handleChangeTake(val, 'all')"
                :pageOptions="pageOptions"
                :filter="all.filter"
                :rows="all.rows"
                @pagination="(val) => pagination(val, 'all')"
              />
            </b-tab>
            <!-- <b-tab :title="`สินค้า (${booth.rows})`">
              <div class="d-flex justify-content-start align-items-end">
                <InputText
                  v-model="booth.filter.search"
                  textFloat="ค้นหา"
                  type="text"
                  name="search_product"
                  faIcon="search"
                  className="my-2 w-50"
                  @onEnter="(val) => handleSearch(val, 'booth')"
                  @onClickIcon="(val) => handleSearch(val, 'booth')"
                />
                <div>
                  <img
                    src="@/assets/images/icons/bin.png"
                    alt="delete"
                    class="pointer mb-2 ml-2"
                    center
                    width="32"
                    @click="handleSearch('', 'booth')"
                  />
                </div>
              </div>
              <b-row>
                <b-col>
                  <b-table
                    responsive
                    striped
                    hover
                    :fields="fields"
                    :items="booth.items"
                    :busy="booth.isBusy"
                    show-empty
                    empty-text="No matching records found"
                    class="table-main"
                    :no-border-collapse="false"
                  >
                    <template v-slot:cell(select)="data">
                      <b-button
                        variant="primary-color"
                        class="btn-modal btn-hover"
                        @click="selectRow(data.item, 'booth')"
                        :disabled="booth.isBusy"
                      >
                        เลือก
                      </b-button>
                    </template>
                    <template v-slot:cell(name)="data">
                      <b>{{ data.item.name || "-" }}</b>
                      <p>{{ data.item.category_name || "-" }}</p>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div>
                        {{ data.item.price | numeral("0,0.00") }}
                      </div>
                    </template>
                    <template v-slot:table-busy>
                      <div class="text-center text-black my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-2">Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <Pagination
                @handleChangeTake="(val) => handleChangeTake(val, 'booth')"
                :pageOptions="pageOptions"
                :filter="booth.filter"
                :rows="booth.rows"
                @pagination="(val) => pagination(val, 'booth')"
              />
            </b-tab> -->
            <!-- <b-tab :title="`บริการสปา (${spa.rows})`">
              <div class="d-flex justify-content-start align-items-end">
                <InputText
                  v-model="spa.filter.search"
                  textFloat="ค้นหา"
                  type="text"
                  name="search_product"
                  faIcon="search"
                  className="my-2 w-50"
                  @onEnter="(val) => handleSearch(val, 'spa')"
                  @onClickIcon="(val) => handleSearch(val, 'spa')"
                />
                <div>
                  <img
                    src="@/assets/images/icons/bin.png"
                    alt="delete"
                    class="pointer mb-2 ml-2"
                    center
                    width="32"
                    @click="handleSearch('', 'spa')"
                  />
                </div>
              </div>
              <b-row>
                <b-col>
                  <b-table
                    responsive
                    striped
                    hover
                    :fields="fields"
                    :items="spa.items"
                    :busy="spa.isBusy"
                    show-empty
                    empty-text="No matching records found"
                    class="table-main"
                    :no-border-collapse="false"
                  >
                    <template v-slot:cell(select)="data">
                      <b-button
                        variant="primary-color"
                        class="btn-modal btn-hover"
                        @click="selectRow(data.item, 'spa')"
                        :disabled="spa.isBusy"
                      >
                        เลือก
                      </b-button>
                    </template>
                    <template v-slot:cell(name)="data">
                      <b>{{ data.item.name || "-" }}</b>
                      <p>{{ data.item.category_name || "-" }}</p>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div>
                        {{ data.item.price | numeral("0,0.00") }}
                      </div>
                    </template>
                    <template v-slot:table-busy>
                      <div class="text-center text-black my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-2">Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <Pagination
                @handleChangeTake="(val) => handleChangeTake(val, 'spa')"
                :pageOptions="pageOptions"
                :filter="spa.filter"
                :rows="spa.rows"
                @pagination="(val) => pagination(val, 'spa')"
              />
            </b-tab> -->
          </b-tabs>
        </div>
      </div>
    </b-modal>
    <ModalNote ref="modalNote" :branchId="branchId" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import OtherLoading from "@/components/loading/OtherLoading";
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import ModalNote from "@/components/customer/ModalNote";
import HeaderPanel from "@/components/HeaderPanel";
import InputDatePickerFilter from "@/components/inputs/InputDatePickerFilter";

export default {
  components: {
    OtherLoading,
    Pagination,
    InputText,
    ModalNote,
    HeaderPanel,
    InputDatePickerFilter,
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      all: {
        filter: {
          search: "",
          datetime: "",
          branchId: "",
          page: 1,
          take: 5,
        },
        items: [],
        isBusy: false,
        rows: 0,
      },
      booth: {
        filter: {
          search: "",
          datetime: "",
          branchId: "",
          page: 1,
          take: 5,
        },
        items: [],
        isBusy: false,
        rows: 0,
      },
      spa: {
        filter: {
          search: "",
          datetime: "",
          branchId: "",
          page: 1,
          take: 5,
        },
        items: [],
        isBusy: false,
        rows: 0,
      },

      fields: [
        {
          key: "select",
          label: "",
        },
        {
          key: "barcode",
          label: "รหัสสินค้า",
          id: 5,
        },
        {
          key: "name",
          label: "ชื่อสินค้า",
          tdClass: "text-left",
          id: 1,
        },
        {
          key: "price",
          label: "ราคาสินค้า",
          id: 2,
        },
      ],
      now: null,
      expireDate: null,
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      isSpa: true,
      isBooth: true,
      tabIndex: 0,
      user: null,
    };
  },
  computed: {
    ...mapGetters({
      dateTimeFix: "getDateTimeFix",
      branchId: "getBranchId",
    }),
  },

  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async show(user, search) {
      this.now = this.$moment().format("YYYY-MM-DDTHH:mm:ss");

      this.user = user;
      this.tabIndex = 0;
      this.all.filter.search = search;
   
      await this.getSearchAll();
      // await this.getSearchBooth();
      // await this.getSearchSpa();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    pagination(page, key) {
      this[key].filter.page = page;
      this.searchByTab();
    },
    handleChangeTake(value, key) {
      this[key].filter.page = 1;
      this[key].filter.take = value;
      this.searchByTab();
    },
    handleSearch(search, key) {
      this[key].filter.search = search;
      this.searchByTab();
    },
    searchByTab() {
      if (this.tabIndex == 0) this.getSearchAll();
      else if (this.tabIndex == 1) this.getSearchBooth();
      else if (this.tabIndex == 2) this.getSearchSpa();
    },
    async selectRow(item, key) {
      await this.setSelectProduct(item, key);
      await this.hide();
    },
    setSelectProduct(item, key) {
      this.$emit("setSelectProduct", item, key);
    },

    async getSearchAll() {
      let body = {
        articleType: "",
        ah2_id: null,
        ah3_id: null,
        ah4_id: null,
        search: this.all.filter.search || "",
        skip: (this.all.filter.page - 1) * this.all.filter.take,
        take: this.all.filter.take,
        spa: this.isSpa,
        booth: this.isBooth,
        branch_id: this.branchId,
      };
      await this.axios
        .post(`${this.$baseUrl}/product/search_all_product`, body)
        .then(async (data) => {
          if (data.result == 1) {
            await this.$store.dispatch("getDynamicFields", {
              products_id: data.detail.map((el) => el.product_id),
              body: data.detail,
              serials_id: [],
              fields: this.fields,
            });

            this.all.items = data.detail;
            this.all.rows = data.total_count;
          }
        });
    },
    async getSearchBooth() {
      let body = {
        articleType: "ZFIN",
        ah2_id: null,
        ah3_id: null,
        ah4_id: null,
        search: this.booth.filter.search,
        skip: (this.booth.filter.page - 1) * this.booth.filter.take,
        take: this.booth.filter.take,
        spa: this.isSpa,
        booth: this.isBooth,
        branch_id: this.branchId,
      };
      if (this.isBooth) {
        await this.axios
          .post(`${this.$baseUrl}/product/search_all_product`, body)
          .then((data) => {
            if (data.result == 1) {
              this.booth.items = data.detail;
              this.booth.rows = data.total_count;
            }
          });
      }
    },
    async getSearchSpa() {
      let body = {
        articleType: "ZPACK",
        ah2_id: null,
        ah3_id: null,
        ah4_id: null,
        search: this.spa.filter.search,
        skip: (this.spa.filter.page - 1) * this.spa.filter.take,
        take: this.spa.filter.take,
        spa: this.isSpa,
        booth: this.isBooth,
        branch_id: this.branchId,
      };
      if (this.isSpa) {
        await this.axios
          .post(`${this.$baseUrl}/product/search_all_product`, body)
          .then((data) => {
            if (data.result == 1) {
              this.spa.items = data.detail;
              this.spa.rows = data.total_count;
            }
          });
      }
    },
    async addCredit() {
      await this.$emit("addCredit", this.credit.form);
      await this.hide();
    },
    inputExpiredDate(val) {
      this.credit.form.expired_date = val;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  color: #fff;
  width: 100%;
  background-color: var(--primary-color);
}
::v-deep .modal-body {
  padding: 1rem 1rem;
}
.btn-primary .modal-body {
  margin: auto;
  text-align: center;
}
::v-deep .nav-tabs li {
  border-left: 1px solid white;
  border-right: 1px solid white;
}
.credit-panel {
  background-color: var(--secondary-color);
  padding: 10px 10px;
  .total {
    font-size: 20px;
  }
}
::v-deep .table-credit {
  .table.b-table > thead > tr > th {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
}

::v-deep .table-main {
  &:not(.table-credit) {
    table {
      // min-height: 360px;
    }
  }
}
</style>
